module.exports = __webpack_public_path__ + "img/IMG_1867_L_Black.55240e23.jpg";